import { render, staticRenderFns } from "./MultiQueueRulesDashboard.vue?vue&type=template&id=019d4e41&scoped=true"
import script from "./MultiQueueRulesDashboard.vue?vue&type=script&lang=js"
export * from "./MultiQueueRulesDashboard.vue?vue&type=script&lang=js"
import style0 from "./MultiQueueRulesDashboard.vue?vue&type=style&index=0&id=019d4e41&prod&lang=scss"
import style1 from "./MultiQueueRulesDashboard.vue?vue&type=style&index=1&id=019d4e41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019d4e41",
  null
  
)

export default component.exports